import { useState, useEffect, useContext, Fragment } from "react";
import {
    Button,
    Grid,
    TextField,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ActionContext } from 'src/contexts/ActionContext';
import { BusinessManagerContext } from "src/contexts/BusinessManagerContext";
import AddBoxIcon from '@mui/icons-material/AddBox';
import DialogLinguisticSkill from "src/components/Dialog/FicheEEPBM/DialogLinguisticSkill";
import ASMDialogConfirmation from "src/components/Dialog/ASMDialogConfirmation";
import LinguisticSkillItem from "./LinguisticSkillItem";
import EmptyMessage from "src/components/Message/EmptyMessage";
import { EEPLanguageModel } from "src/models/businessManager/businessManager.model";
import { eepLanguageService, languageService } from "src/services";
import { LanguageLevel } from "src/models/languageLevel.model";
import { CURRENT_LANG } from "src/constants";
import IconButton from 'src/components/Button/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ASMAlert from "src/components/Alert";
import { EEPLanguageContext } from 'src/contexts/EEPLanguageContext';
import { SelectDTO } from "src/models/selectDTO.model";

const requireStyle = {
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'red !important',
    },
    '& .MuiInputLabel-root': {
        color: 'red !important',
    }
};
function SkillsAssessment(props) {
    const { t } = useTranslation();
    const { REACT_APP_NOTIFICATION_DURATION } = process.env;
    const { eepBMData } = useContext(BusinessManagerContext);
    const { actionToggle } = useContext(ActionContext);
    const { setEEPLanguageDataContext } = useContext(EEPLanguageContext);
    const isVisu = !actionToggle;
    const [data, setData] = useState({
        strengthsManager: '',
        areasOfProgress: '',
        actionsToBeImplemented: '',
    });
    const [openDialogLinguisticSkill, setOpenDialogLinguisticSkill] = useState(false)
    const [idToDelete, setIdToDelete] = useState({
        index: 0,
        id: 0
    });
    const [openDialogDelete, setOpenDialogDelete] = useState<boolean>(false);
    const [EEPLanguageData, setEEPLanguageData] = useState<EEPLanguageModel[]>([]);
    const lang = localStorage.getItem(CURRENT_LANG) === 'en' ? 2 : 1;
    const [levels, setLevels] = useState<LanguageLevel[]>();
    const [displayAlert, setDisplayAlert] = useState<boolean>(false);
    const [displayAlertError, setDisplayAlertError] = useState<boolean>(false);
    const [state, setState] = useState<EEPLanguageModel>({
        id: 0,
        idEa: 0,
        name: "",
        idLanguageLevel: 0
    });

    useEffect(() => {
        let request = {
            idLang: lang
        };
        languageService.getAllLevel(request).then(response => {
            if (response.data.success) {
                setLevels(response.data.data);
            }
        });
    }, []);
    const levelsItems: SelectDTO[] = levels?.map(option => {
        return (
            {
                label: option.name,
                value: option.id
            }
        )
    });
    useEffect(() => {
        if (props.idEEPBM != 0) {
            eepLanguageService.getByIdEa(props.idEEPBM).then(response => {
                if (response.data.success) {
                    setEEPLanguageData(response.data.data)
                    setEEPLanguageDataContext(response.data.data)
                }
            })
        }
    }, [props.idEEPBM]);

    useEffect(() => {
        setData({
            strengthsManager: props.data.strengthsManager,
            areasOfProgress: props.data.areasOfProgress,
            actionsToBeImplemented: props.data.actionsToBeImplemented,
        });
    }, [props.data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value
        });
    }
    const setDataContextValue = () => {
        eepBMData.strengthsManager = data.strengthsManager;
        eepBMData.areasOfProgress = data.areasOfProgress;
        eepBMData.actionsToBeImplemented = data.actionsToBeImplemented;
    }
    const handleOpenDialogDelete = (i, id) => {
        setIdToDelete({
            index: i,
            id: id
        })
        setOpenDialogDelete(true)
    }
    const handleChangeLinguisticSkill = (e) => {
        const { name, value } = e.target;
        setState({
            ...state,
            idEa: props.idEEPBM,
            [name]: value
        });
    }

    const handleChangeLevel = (e) => {
        setState({
            ...state,
            idEa: props.idEEPBM,
            idLanguageLevel: e.target.value
        });
    }

    const onBlur = (obj) => {
        setEEPLanguageData(all =>
            all.map(data => {
                if (data.id === obj.id) {
                    return obj;
                }
                return data;
            })
        );
        setEEPLanguageDataContext(EEPLanguageData);
    }

    const handleChangeDataValue = (obj) => {
        setEEPLanguageData(all =>
            all.map(data => {
                if (data.id === obj.id) {
                    return obj;
                }
                return data;
            })
        );
    }

    const handleClickDelete = () => {
        eepLanguageService.deleteEEPLanguage(idToDelete.id).then(response => {
            if (response.data.success && response.data.data) {
                let array = [...EEPLanguageData];
                array.splice(idToDelete.index, 1);
                setEEPLanguageData(array);
                setEEPLanguageDataContext(array);
                setDisplayAlert(true);
                setTimeout(() => {
                    setDisplayAlert(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                setOpenDialogDelete(false);
            } else {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }
        }).catch(err => {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        });
    }

    const handleCloseDialogSave = () => {
        setState({
            id: 0,
            idEa: 0,
            name: "",
            idLanguageLevel: 0
        })
        setOpenDialogLinguisticSkill(false);
    }

    const handleClickSave = () => {
        if (state.name != '' && state.idLanguageLevel != 0) {
            eepLanguageService.insert(state).then(response => {
                if (response.data.success && response.data.data != null) {
                    setEEPLanguageData([...EEPLanguageData, response.data.data])
                    setOpenDialogLinguisticSkill(false);
                    setState({
                        id: 0,
                        idEa: 0,
                        name: "",
                        idLanguageLevel: 0
                    })
                    setDisplayAlert(true);
                    setTimeout(() => {
                        setDisplayAlert(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                } else {
                    setDisplayAlertError(true);
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true);
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            });
        } else {
            setDisplayAlertError(true);
            setTimeout(() => {
                setDisplayAlertError(false);
            }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
        }
    }
    return (
        <>
            <ASMAlert message={t('action.success')} severity="success" open={displayAlert} />
            <ASMAlert message={t('action.error')} severity="error" open={displayAlertError} />
            <Grid item xs={12}>
                <h3 style={{ fontStyle: 'italic', fontWeight: 'normal', marginLeft: 2, marginRight: 2 }}>
                    <Trans>eepBm.skillsAssessment.label</Trans>
                </h3>
            </Grid>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid container direction="row" alignItems="stretch" style={{
                    backgroundColor: '#2c9a42',
                    color: '#ffffff',
                    height: 50,
                    textAlign: 'center',
                    fontSize: 12,
                    textTransform: 'uppercase',
                    marginTop: 15,
                    borderRadius: 3
                }}>
                    <Grid item xs={12} >
                        <h3><Trans>eepBm.skillsAssessment.title1</Trans></h3>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        <TextField
                            label={''}
                            variant="outlined"
                            fullWidth
                            name="strengthsManager"
                            value={data.strengthsManager}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
            </div>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid container direction="row" alignItems="stretch" style={{
                    backgroundColor: '#2c9a42',
                    color: '#ffffff',
                    height: 50,
                    textAlign: 'center',
                    fontSize: 12,
                    textTransform: 'uppercase',
                    marginTop: 15,
                    borderRadius: 3
                }}>
                    <Grid item xs={6} >
                        <h3><Trans>eepBm.skillsAssessment.title2</Trans></h3>
                    </Grid>
                    <Grid item xs={6} >
                        <h3><Trans>eepBm.skillsAssessment.title3</Trans></h3>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={6} >
                        <TextField
                            label=""
                            variant="outlined"
                            fullWidth
                            name="areasOfProgress"
                            value={data.areasOfProgress}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label=""
                            variant="outlined"
                            fullWidth
                            name="actionsToBeImplemented"
                            value={data.actionsToBeImplemented}
                            onChange={handleChange}
                            onBlur={setDataContextValue}
                            multiline
                            inputProps={{
                                maxLength: 4094
                            }}
                            disabled={isVisu}
                        />
                    </Grid>
                </Grid>
            </div>
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid container direction="row" alignItems="stretch" style={{
                    backgroundColor: '#2c9a42',
                    color: '#ffffff',
                    height: 50,
                    textAlign: 'center',
                    fontSize: 12,
                    textTransform: 'uppercase',
                    marginTop: 15,
                    borderRadius: 3
                }}>
                    <Grid item xs={12} >
                        <h3><Trans>eepBm.skillsAssessment.title4</Trans></h3>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                    <Grid item xs={12} >
                        {EEPLanguageData.length != 0 ?
                            EEPLanguageData.map((item, index) => {
                                return (
                                    <LinguisticSkillItem
                                        key={index}
                                        isVisu={isVisu}
                                        levels={levelsItems}
                                        data={item}
                                        onBlur={onBlur}
                                        handleChangeDataValue={handleChangeDataValue}
                                        deleteComponent={
                                            <>
                                                <IconButton
                                                    variant="contained"
                                                    color="error"
                                                    width={40}
                                                    icon={
                                                        <DeleteIcon
                                                            style={{ fontSize: 25 }}
                                                            onClick={() => handleOpenDialogDelete(index, item.id)}
                                                        />
                                                    }
                                                    disabled={isVisu}
                                                />
                                            </>
                                        }
                                    />

                                )
                            }
                            )
                            : <EmptyMessage withAddition />}
                    </Grid>
                    {!isVisu && <Grid item xs={12} >
                        <Button variant="contained"
                            style={{ backgroundColor: '#ffffff', color: '#00b0be', border: '2px #00b0be solid', marginRight: 20 }}
                            startIcon={<AddBoxIcon style={{ fontSize: 25 }} />}
                            onClick={() => setOpenDialogLinguisticSkill(true)}
                            disabled={isVisu}>
                            <Trans>button.add</Trans>
                        </Button>
                    </Grid>}
                </Grid>
            </div>
            <DialogLinguisticSkill
                data={state}
                levels={levelsItems}
                handleChange={handleChangeLinguisticSkill}
                handleChangeLevel={handleChangeLevel}
                openDialogSave={openDialogLinguisticSkill}
                handleCloseDialogSave={handleCloseDialogSave}
                handleClickSave={handleClickSave}
                title={t('eepBm.skillsAssessment.addDialogTitle')}
            />
            <ASMDialogConfirmation
                title={t('dialog.confirmation')}
                text={t('deleteMessage')}
                open={openDialogDelete}
                onConfirm={handleClickDelete}
                onClose={() => setOpenDialogDelete(false)}
                data={3}
            />
        </>
    );
}

export default SkillsAssessment;